import React, {useMemo, useState} from 'react';
import {useTranslation} from 'react-i18next';


export const AgentClientSelector = ({clients, isLoading, onClientSelected}) => {
    const {t} = useTranslation();
    const [selectedId, setSelectedId] = useState(null);
    const [search, setSearch] = useState('');

    const filtered = useMemo(() => {
        if (!search.trim()) return clients;
        const q = search.trim().toLowerCase();
        return clients.filter(c => c.name.toLowerCase().includes(q));
    }, [clients, search]);

    const handleContinue = () => {
        if (selectedId !== null) {
            onClientSelected(selectedId);
        }
    };

    const handleDoubleClick = (clientId) => {
        onClientSelected(clientId);
    };

    return (
        <div className="agent-client-selector">
            <div className="agent-client-selector__icon">
                <i className="fas fa-robot"></i>
            </div>
            <h3 className="agent-client-selector__title">
                {t('agent_chat.select_client_title')}
            </h3>

            {isLoading ? (
                <div className="agent-client-selector__loading">
                    <i className="fas fa-spinner fa-spin"></i>
                    <span>{t('agent_chat.select_client_loading')}</span>
                </div>
            ) : (
                <>
                    <div className="agent-client-selector__search">
                        <i className="fas fa-search agent-client-selector__search-icon"></i>
                        <input
                            type="text"
                            className="agent-client-selector__search-input"
                            placeholder={t('agent_chat.select_client_search')}
                            value={search}
                            onChange={e => setSearch(e.target.value)}
                            autoFocus
                        />
                    </div>

                    <div className="agent-client-selector__list">
                        {filtered.length === 0 && (
                            <div className="agent-client-selector__empty">
                                {t('agent_chat.select_client_no_results')}
                            </div>
                        )}
                        {filtered.map(client => (
                            <div
                                key={client.id}
                                className={`agent-client-selector__item ${selectedId === client.id ? 'agent-client-selector__item--selected' : ''}`}
                                onClick={() => setSelectedId(client.id)}
                                onDoubleClick={() => handleDoubleClick(client.id)}
                            >
                                <span className="agent-client-selector__item-avatar">
                                    {client.name.charAt(0).toUpperCase()}
                                </span>
                                <span className="agent-client-selector__item-name">
                                    {client.name}
                                </span>
                                {selectedId === client.id && (
                                    <i className="fas fa-check agent-client-selector__item-check"></i>
                                )}
                            </div>
                        ))}
                    </div>

                    <button
                        className="btn -alt agent-client-selector__continue-btn"
                        onClick={handleContinue}
                        disabled={selectedId === null}
                    >
                        {t('agent_chat.select_client_continue')}
                    </button>
                </>
            )}
        </div>
    );
};
